import lang from '../../../lang/index.js';
export default function numeric() {
    /* eslint-disable */
    return this.matches(/^\d+$/, lang().validation.integer());
    /* eslint-enable */
}
//# sourceMappingURL=index.js.map